function formateQuery(defaultQuery, params){
    for (let key in params) {
        // 检测合法性
        if (defaultQuery.hasOwnProperty(key)) {
            // 合并数据
            switch (key) {
                case 'ele':
                    if (document.body.contains(params.ele) || document.body.contains(document.getElementById(params.ele))) {
                        defaultQuery.ele = params.ele;
                    }
                    break;
                case 'autoplay':
                case 'muted':
                    if (typeof params[key] === 'boolean') {
                        defaultQuery[key] = params[key];
                    }
                    break;
                case 'preload':
                    if (/^(auto|metadate|none)$/.test(params.preload)) {
                        defaultQuery.preload = params.preload;
                    }
                    break;
                case 'volume':
                    if (params.volume >= 0 && params.volume <= 1) {
                        defaultQuery.volume = params.volume;
                    }
                    break;
                case 'playbackRate':
                    if (/^(-32|-16|-8|-4|-2|-1|0.5|1|2|4|8|16|32)$/.test(params.playbackRate)) {
                        defaultQuery.playbackRate = params.playbackRate;
                    }
                    break;
                case 'mode':
                    if (/^(single|list|random|none)$/.test(params.mode)) {
                        defaultQuery.mode = params.mode;
                    }
                    break;
                case 'theme':
                    if (/^(default|none)$/.test(params.theme)) {
                        defaultQuery.theme = params.theme;
                    }
                    break;
                case 'switch':
                case 'change':
                    if (typeof params[key] === 'function') {
                        defaultQuery[key] = params[key];
                    }
                    break;
                default:
                    defaultQuery[key] = params[key];
            }
        }
    }
    // 回调
    return {...defaultQuery}
}

function formateTime(time){
    let m = Math.floor(time/60);
    let s = Math.ceil(time%60);

    if(m<=9){
        m = '0' + m.toString();
    }

    if(s<=9){
        s = '0' + s.toString();
    }

    return m +':' + s
}

export {formateQuery,formateTime}